import { type Theme } from '@mui/material/styles'
export const getLayoutConfig = (theme: Theme) => {
  return {
    savings_account_balances_summary: {
      color: theme.palette.success.main,
    },
    monthly_spend_comparison: {
      color: theme.palette.chart.chart2,
    },
  }
}
